"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedDiscountForProductParticipationResponse = exports.mockedDiscountForProductParticipationCreateRequest = void 0;
exports.mockedDiscountForProductParticipationCreateRequest = {
  quantityOfParticipation: 1,
  amountOfDiscount: 1
};
exports.mockedDiscountForProductParticipationResponse = {
  id: 1,
  quantityOfParticipation: 1,
  amountOfDiscount: 1
};